const LS_KEY = 'accessToken'

const tokenService = {
  set: (token: string) => localStorage.setItem(LS_KEY, token),
  get: () => localStorage.getItem(LS_KEY),
  remove: () => localStorage.removeItem(LS_KEY)
}
export default tokenService
